module.exports = __webpack_public_path__ + "static/media/hamburger.e711fc52.svg";